import { createBrowserHistory } from 'history';

export const urlHelper = {
  history: createBrowserHistory(),
};

/**
 * 解析encode 参数
 * @param str
 * @returns string
 */
export const decodeParams = (str?: string) => {
  if (!str) return '';
  try {
    return decodeURIComponent(str);
  } catch (error) {
    return str;
  }
};
